import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 24,
    letterSpacing: 1,
    fontWeight: 'normal',
    marginLeft: 15,
    marginBottom: 20,
  },
}));
